(function () {
    angular.module('tmx-app').factory('PjpSummaryService', ['tmxResource', '$mdMedia', function (tmxResource, $mdMedia) {

        var pjpSummary = tmxResource("PJPMaster");                          
        return pjpSummary;

    }]);
})();